import Storage from "@/utils/storage";
import { handleToken } from "@/utils/Foundation";
import axios from "axios";
import { Toast } from "vant";
import Vue from "vue";
import router from "../router";
import store from "@/store";

Vue.use(Toast);

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  paramsSerializer: (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(item => searchParams.append(key, item));
      } else {
        searchParams.append(key, value);
      }
    });
    return searchParams.toString();
  },
  // paramsSerializer: (params) => {
  // 在请求拦截中配置时间戳需求添加每次请求的时间戳
  //   params.time = new Date().getTime();
  //   return qs.stringify(params, { arrayFormat: "repeat" });
  // },
});

service.interceptors.request.use(
  (config) => {
    let { loading } = config.headers;
    const accessToken = Storage.getItem("token") || store.state.jwt;
    var type = config.method;
    if (type == 'get') {
      var timestamp = new Date().getTime();
      config.url += config.url.indexOf('?') !== -1 ? `&timestamp=${timestamp}` : `?timestamp=${timestamp}`;
    }
    if (!config.timeout) {
      config.timeout = 15000
    }
    // 是否需要loading
    if (loading !== false) {
      config.loading = Toast.loading({
        overlay: true,
        duration: "0",
        forbidClick: true,
      });
    }
    if (accessToken && config.headers.needToken) {
      config.headers["Authorization"] = accessToken;
    }
    // config.headers["brand"] = 0;
    
    const source = router.currentRoute.query.source ? router.currentRoute.query.source : '';
    config.headers["channel"] = source;
    console.log("config", router.currentRoute.query);
    // config.data = {
    // 在请求拦截中配置时间戳需求添加每次请求的时间戳
    //   ...(config.data || {}),
    //   time: new Date().getTime(),
    // };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  async (response) => {
    await closeLoading(response);
    // 部分网关以字符串返回业务码，统一转成数字后再判断，避免 "200" 被误判为失败。
    const code = Number(response.data.code || 200);
    if (code === 401) {
      Toast("请先登录");
    } else if (code !== 200 && code !== 1110 && code !== 1109) {
      // 这里判定的不等于1110，针对的场景是H5的注册落地页，在进件时用户非法提交用不同的手机号同一个身份证进行重复进件的逻辑处理

      // 这里判定的不等于1109，针对的场景是H5的注册落地页，在进件时用户非法提交用同样的身份证姓名进行重复进件的逻辑处理

      // 针对h5ApplyV2接口的报错处理
      if (response.config.url.includes('h5ApplyV2')) {
        return response.data;
      }
      // check 的业务失败文案交给调用页面展示，避免拦截器吞掉响应后又出现前端异常提示。
      if (response.config.returnErrorResponse === true) {
        return response.data;
      }
      Toast(response.data.msg);
    } else {
      return response.data;
    }
  },
  async (error) => {
    await closeLoading(error);
    return Promise.reject(error);
  }
);

export default function request(options) {
  return new Promise((resolve, reject) => {
    if (options && options.keepalive === true) {
      const beaconSent = sendBeaconRequest(options);
      if (beaconSent) {
        resolve({ code: 200, msg: "beacon sent" });
        return;
      }
    }
    if (
      options.headers &&
      options.headers.needToken &&
      options.headers.device
    ) {
      handleToken().then(async (token) => {
        await store.dispatch("setToken", token);
        service(options).then(resolve).catch(reject);
      });
    } else {
      service(options).then(resolve).catch(reject);
    }
  });
}

function sendBeaconRequest(options = {}) {
  if (typeof navigator === "undefined" || !navigator.sendBeacon) {
    return false;
  }
  const method = (options.method || "get").toLowerCase();
  if (method !== "post") {
    return false;
  }

  try {
    const baseURL = options.baseURL || process.env.VUE_APP_BASE_API || "";
    const url = options.url || "";
    const finalUrl = /^https?:\/\//.test(url) ? url : `${baseURL}${url}`;
    const contentType =
      options.headers?.["Content-Type"] ||
      options.headers?.["content-type"] ||
      "application/json;charset=UTF-8";
    const body =
      typeof options.data === "string"
        ? options.data
        : JSON.stringify(options.data || {});
    const blob = new Blob([body], { type: contentType });
    return navigator.sendBeacon(finalUrl, blob);
  } catch (e) {
    return false;
  }
}

/**
 * 关闭全局加载
 * @param target
 */
const closeLoading = (target) => {
  if (!target.config || !target.config.loading) return true;
  return new Promise((resolve) => {
    setTimeout(() => {
      Toast.clear();
      resolve();
    }, 200);
  });
};
